import styled from 'styled-components';
import { tokens } from '@welbe/web-design-system';

export const Container = styled.div`
	width: 100%;
	margin-top: 2.5rem;
	display: grid;
	gap: 10px;
	color: ${tokens.color_gray_dark};

	p {
		margin: 0 0 0 2px;
	}

	button {
		margin-top: 10px;
	}
`;

export const Subtitle = styled.p`
	text-align: center;
	width: 100%;
	font-size: 11px;
`;
